/**
 * @generated SignedSource<<4c47b1cea3092ae43ecae5ab5d2b63dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TopSourceMutation$variables = {
  id: string;
  offset?: number | null;
  top: boolean;
};
export type TopSourceMutation$data = {
  readonly topSource: {
    readonly id: string;
    readonly top: number | null;
  } | null;
};
export type TopSourceMutation = {
  response: TopSourceMutation$data;
  variables: TopSourceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "top"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "top",
        "variableName": "top"
      }
    ],
    "concreteType": "Source",
    "kind": "LinkedField",
    "name": "topSource",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "top",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopSourceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopSourceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bd614730b2caa459063f7117807f3764",
    "id": null,
    "metadata": {},
    "name": "TopSourceMutation",
    "operationKind": "mutation",
    "text": "mutation TopSourceMutation(\n  $id: ID!\n  $top: Boolean!\n  $offset: Int\n) {\n  topSource(id: $id, top: $top, offset: $offset) {\n    id\n    top\n  }\n}\n"
  }
};
})();

(node as any).hash = "74c2b461a3ae4211b83a2b743443504d";

export default node;
